import React from "react";

interface ContentCellBoolProps {
  value?: boolean;
}

const ContentCellBool: React.FC<ContentCellBoolProps> = ({ value }) => {
  let displayText = "";

  if (value === true) {
    displayText = "Yes";
  } else if (value === false) {
    displayText = "No";
  }

  return <span>{displayText}</span>;
};

export default ContentCellBool;
